import classNames from "classnames"
import { FunctionComponent, HTMLProps } from "react"

type DividerProps = {
    margin?: number
    vertical?: boolean
} & HTMLProps<HTMLDivElement>
const Divider: FunctionComponent<DividerProps> = ({ vertical, className, ...rest }) => {
    if (vertical) return <VerticalDivider {...rest} className={className} />
    return <div className={classNames(`h-px bg-gray-700`, className)} {...rest}></div>
}

const VerticalDivider: FunctionComponent<DividerProps> = ({ className, ...rest }) => {
    return (
        <div
            className={classNames("w-px bg-gray-700 self-stretch", className)}
            role="separator"
            aria-orientation="vertical"
            {...rest}
        />
    )
}

export { Divider }
